import type { CurrentUserSearchConfig } from "@/modules/user/api/types"

import { useQuery } from "@tanstack/react-query"

import { QUERY_CACHE_TIME, QUERY_STALE_TIME } from "@/modules/jobAds/client/constants"
import { useLocale } from "@/modules/locales/useLocale"
import { CURRENT_USER_SEARCH_CONFIG_QUERY_KEY } from "@/modules/user/api/constants"
import { getCurrentUserSearchConfig } from "@/modules/user/api/getCurrentUserSearchConfig"
import { getCurrentUserSearchConfigQueryKeys } from "@/modules/user/api/getUserQueryKeys"

import { useCurrentUserFetch } from "./useCurrentUserFetch"

export type CurrentUserSearchConfigFetch = {
  dataCurrentUserSearchConfig?: CurrentUserSearchConfig
  isLoadingCurrentUserSearchConfig: boolean
  isSuccessCurrentUserSearchConfig: boolean
  isErrorCurrentUserSearchConfig: boolean
}
export const useCurrentUserSearchConfigFetch = (): CurrentUserSearchConfigFetch => {
  const currentLocale = useLocale()

  const { dataCurrentUser } = useCurrentUserFetch()
  const isLogged = !!dataCurrentUser?.isLogged

  const {
    data: dataCurrentUserSearchConfig,
    isPending: isLoadingCurrentUserSearchConfig,
    isSuccess: isSuccessCurrentUserSearchConfig,
    isError: isErrorCurrentUserSearchConfig,
  } = useQuery({
    gcTime: QUERY_CACHE_TIME,
    queryFn: () =>
      getCurrentUserSearchConfig({
        locale: currentLocale,
      }),
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getCurrentUserSearchConfigQueryKeys({ isLogged, queryKey: CURRENT_USER_SEARCH_CONFIG_QUERY_KEY }),
    staleTime: QUERY_STALE_TIME,
  })

  return {
    dataCurrentUserSearchConfig,
    isErrorCurrentUserSearchConfig,
    isLoadingCurrentUserSearchConfig,
    isSuccessCurrentUserSearchConfig,
  }
}
